import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/connect";

const StorageRequirements = ({ onStorageRequirementsSelected }) => {
  const [selectedStorageRequirements, setSelectedStorageRequirements] =
    useState(null);
  const [variations, setVariations] = useState([]);
  const { prodcode } = useParams();

  const getAllProductVariations = async () => {
    try {
      const response = await fetch(
        `https://ghmarkets.net/test/ghmarketconnect/?ghw=productservices&svg=fashionvariations&prcode=${prodcode}`
      );
      const json = await response.json();
      const firstResult = json["results"][0];
      if (firstResult && firstResult.storagerequirements) {
        const storageRequirementsObject = firstResult.storagerequirements;
        if (storageRequirementsObject.trim() !== "") {
          setVariations(storageRequirementsObject.split(","));
        }
      }
    } catch (error) {
      // Handle error here
    }
  };

  useEffect(() => {
    getAllProductVariations();
  }, [prodcode]);

  const handleStorageRequirementsClick = (storagerequirements) => {
    setSelectedStorageRequirements(storagerequirements);
    onStorageRequirementsSelected(storagerequirements);
  };

  return variations.length > 0 ? (
    <div
      className="sizes-container"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <span
        style={{
          fontSize: "",
          fontWeight: "bold",
          color: "black",
          marginTop: "12px",
        }}
      >
        Storage Requirements:
      </span>
      <div className="sizes">
        {variations.map((variation, i) => (
          <div
            key={i}
            className={`size ${selectedStorageRequirements === variation ? "selected" : ""}`}
            onClick={() => handleStorageRequirementsClick(variation)}
          >
            {variation}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default StorageRequirements;
